// extracted by mini-css-extract-plugin
module.exports = {"LastResult":"LastResult_LastResult__1JaoY","bracket":"LastResult_bracket__15Z3r","row":"LastResult_row__rKsES","number":"LastResult_number__jrnEA","win":"LastResult_win__q4LXf"};